module.exports = function() {
	return new Worker(__webpack_public_path__ + "worker-slave.parallel.js");
};


//////////////////
// WEBPACK FOOTER
// ./~/worker-loader?name=worker-slave!./src/browser/worker-slave/index.ts
// module id = 166
// module chunks = 0 1


// WEBPACK FOOTER //
// webpack:///src/browser/worker-slave/index.ts